module.exports = __webpack_public_path__ + "static/media/snowflake.bd967a24.png";